export default __webpack_public_path__ + "static/media/yair-sharki.1362fdd6.png";